module.exports = __webpack_public_path__ + "static/img/senceIcon3.714a35f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/senceIcon3.png
// module id = Ts4d
// module chunks = 1